import axios from 'axios';
import { API_HOST } from '../constants/constants';
import useCurrentUser from '../hooks/useCurrentUser';

export const getBenefitDetails = async (patientID) => {
  const { userID, token } = useCurrentUser();
  let apiURL;
  if (patientID) {
    apiURL = `${API_HOST}/orders/benefit_details?user_id=${patientID}`;
  } else {
    apiURL = `${API_HOST}/orders/benefit_details?user_id=${userID}`;
  }

  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'x-dqpn-user-id': userID,
      },
    });

    // console.log('here is the data from getBenefitDetails: ', data);
    // console.log('here is the userid from getBenefitDetails: ', userID);
    return data;
  } catch (error) {
    console.error('Error fetching benefit details:', error);
    return null;
  }
};
